/*
 * Copyright (c) 2017 Datarista, Inc.
 */

export AccountsPageContainer from './superadmin/AccountsPageContainer';
export AdminDatasetsContainer from './superadmin/AdminDatasetsContainer';
export ConfigureFormPage from './superadmin/ConfigureFormPage';
export CreateAccountPage from './superadmin/CreateAccountPage';
export ViewAccountContainer from './superadmin/ViewAccountContainer';
export CreateOrderPage from './orders/CreateOrderPage';
export CustomerIndexContainer from './customer_portal/CustomerIndexContainer';
export DataIndex from './data/DataIndex';
export EditAccountPage from './superadmin/EditAccountPage';
export FilesetPageContainer from './superadmin/FilesetPageContainer';
export FilesetPreviewContainer from './data/FilesetPreviewContainer';
export ForgotPasswordPage from './account/ForgotPasswordPage';
export groupSKUPage from './data/groupSKUPage';
export HomeIndexContainer from './home/HomeIndexContainer';
export AccountPlatformsPageContainer from './superadmin/AccountPlatformsPageContainer';
export JobsPage from './superadmin/JobsPage';
export JobsPageContainer from './superadmin/JobsPageContainer';
export LoginPage from './account/LoginPage';
export MyAccount from './account/MyAccount';
export NewListContainer from './data/NewListContainer';
export NotFound from './shared/NotFound';
export OrdersIndexContainer from './orders/OrdersIndexContainer';
export ViewOrderContainer from './orders/ViewOrderContainer';
export UploadPrematchedContainer from './orders/UploadPrematchedContainer';
export PasswordResetPage from './account/PasswordResetPage';
export PasswordSetPage from './account/PasswordSetPage';
export PricingIndexContainer from './pricing/PricingIndexContainer';
export ProductsIndexContainer from './products/ProductsIndexContainer';
export RenderCurrentHomepage from './shared/RenderCurrentHomepage';
export DataReportsPageContainer from './reports/DataReportsPageContainer';
export SingleDatasetReportsPage from './reports/SingleDatasetReportsPage';
export ReportViewContainer from './reports/ReportViewContainer';
export ActivityReportsPage from './reports/ActivityReportsPage';
export BillingReportsPage from './reports/BillingReportsPage';
export OrderReportsPage from './reports/OrderReportsPage';
export SingleDatasetContainer from './data/SingleDatasetContainer';
export SuperadminEditPage from './superadmin/SuperadminEditPage';
export SuperadminPricingContainer from './superadmin/SuperadminPricingContainer';
export TemplateContainer from './TemplateContainer';
export TokenPage from './superadmin/TokenPage';
export AccountOrdersPageContainer from './superadmin/AccountOrdersPageContainer';
export UserEditContainer from './users/UserEditContainer';
export UsersIndexContainer from './users/UsersIndexContainer';
export PrivacyPolicy from './shared/PrivacyPolicy';
export OrderOverviewReportContainer from './reports/OrderOverviewReportContainer';
export OrderReportContainer from './reports/OrderReportContainer';
export MatchedPairReportContainer from './reports/MatchedPairReportContainer';

// Customer Portal Specific
export CreateCustomerAccount from './customer_portal/CreateCustomerAccountContainer';
export UserSettings from './customer_portal/UserSettingsContainer';
export Prospecting from './customer_portal/Prospecting';
export AdminIndex from './customer_portal/admin/AdminIndex';
